export { UserDetailsSection } from './user-details-section';
